import { render, staticRenderFns } from "./infoLotto.vue?vue&type=template&id=3c6203d0"
import script from "./infoLotto.vue?vue&type=script&lang=js"
export * from "./infoLotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports